import React, { useState, useEffect } from 'react';
import Network from '../../../models/Network.js';

import TestListElement from '../list_elements/TestListElement.js';
import LoadingListElement from '../list_elements/LoadingListElement.js';
import './Module.css';

const key = process.env.REACT_APP_CLIENT_ACCESS_KEY;
const URLS = require("../../../urls.js");

const StatusCodes = require('../../../status-codes/status-codes.js')
const ErrorCodes = require('../../../error-codes/error-codes.js')

const ReportTestsModule = ({user, reportId, isSmallScreen}) => {
    const [allChecksData, setAllChecksData] = useState(null);
    const [checkFlagToUpdate, setCheckFlagToUpdate] = useState(null);

    // function that gets one report's checks from the server
    const getOneReportChecks = async (reportId) => {
        const url = URLS.GET_ONE_REPORT_CHECKS;
        const dict = {
            // uid: user.uid,
            report_id: reportId,
            CLIENT_ACCESS_KEY: key
        };
        let responseData;

        await Network.post(url, dict, (response) => {
            responseData = response.data;
            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something
            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")
            } else {
                console.log("Unknown Error")
            }
        });
        return responseData;
    };

    useEffect(() => {
        getOneReportChecks(reportId)
            .then((results) => {
                setAllChecksData(results);
            })
            .catch((error) => {
                console.log('Error:', error);
            });
    }, []);

    useEffect(() => {
        if (checkFlagToUpdate !== null && checkFlagToUpdate !== undefined) {
            updateOverriddenStatus(
                checkFlagToUpdate.checkFlagData,
                checkFlagToUpdate.overriddenStatus,
                checkFlagToUpdate.objectType
            );
        }
    }, [checkFlagToUpdate]);

    const updateOverriddenStatus = async (checkFlagData, overriddenStatus, objectType) => {
        console.log('objectType status update:', objectType);
        let currentOverriddenStatus = overriddenStatus ? 'overridden' : 'unoverridden';
        console.log('Current Overridden Status being pushed:', currentOverriddenStatus);
        
        let dict = null;
        let url = null;

        // check type here
        if (objectType === 'check') {
            url = URLS.UPDATE_CHECK_OVERRIDE;
            dict = {
                overridden_status: currentOverriddenStatus,
                agency_uid: checkFlagData.reports_agencies_uid,
                report_id: checkFlagData.reports_report_id,
                test_metadata_id: checkFlagData.test_metadata_test_metadata_id,
                CLIENT_ACCESS_KEY: key
            };
        }

        let responseData;
        await Network.post(url, dict, (response) => {
            responseData = response.data;
            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something
            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")
            } else {
                console.log("Unknown Error")
            }
        });
        return responseData;
    };

    const handleOverrideButtonClick = (checkOrFlag) => {
        let checkFlagToUpdate = {
            checkFlagData: checkOrFlag['checkFlagData'],
            overriddenStatus: checkOrFlag['overriddenStatus'],
            objectType: checkOrFlag['objectType']
        };
        setCheckFlagToUpdate(checkFlagToUpdate);
    };

    const createTestListElement = (testData) => {
        return (
            <TestListElement
                testData={testData}
                onButtonClick={handleOverrideButtonClick}
            />
        );
    };

    // Filter and categorize test results
    const categorizeTestResults = (testData) => {
        if (!testData) return {
            checks: [],
            measures: [],
            quantMeasures: [],
            narrativeSuggestions: [],
            other: []
        };

        return testData.reduce((categories, testData) => {
            const impactAttribute = testData['impact_attribute'];
            
            if (impactAttribute === 'check') {
                categories.checks.push(testData);
            } else if (impactAttribute === 'measure') {
                categories.measures.push(testData);
            } else if (impactAttribute === 'quant-measure') {
                categories.quantMeasures.push(testData);
            } else if (impactAttribute === 'narrative-suggestion') {
                categories.narrativeSuggestions.push(testData);
            } else {
                categories.other.push(testData);
            }
            
            return categories;
        }, {
            checks: [],
            measures: [],
            quantMeasures: [],
            narrativeSuggestions: [],
            other: []
        });
    };

    const renderTestSection = (title, testResults, sectionKey) => {
        if (!testResults || testResults.length === 0) {
            return null;
        }

        return (
            <div key={sectionKey}>
                <h2 className='module-title' style={{ paddingTop: '40px' }}>{title}</h2>
                <div>
                    {testResults.map((testData) => createTestListElement(testData))}
                </div>
            </div>
        );
    };

    const categories = categorizeTestResults(allChecksData);

    return (
        <div className={isSmallScreen ? "standard-module-screen-small" : "standard-module"}>
            <div>
                {allChecksData && (
                    <div style={{ marginBottom: '20px', fontSize: '16px', color: '#666' }}>
                        Total Tests Run on this Report: <strong>{allChecksData.length}</strong>
                    </div>
                )}
            </div>
            
            {allChecksData ? (
                <div>
                    {renderTestSection('Checks', categories.checks, 'checks')}
                    {renderTestSection('Measures', categories.measures, 'measures')}
                    {renderTestSection('Quantitative Measures', categories.quantMeasures, 'quant-measures')}
                    {renderTestSection('Narrative Suggestions', categories.narrativeSuggestions, 'narrative-suggestions')}
                    {renderTestSection('Other Tests', categories.other, 'other')}
                    
                    {Object.values(categories).every(category => category.length === 0) && (
                        <div>No test results available for this report</div>
                    )}
                </div>
            ) : (
                <div>Loading Test Results...</div>
            )}
        </div>
    );
}

export default ReportTestsModule;
